import React, { useState } from "react";

import CreateEnrollmentFormModal from "components/module/CreateEnrollmentFormModal";
import { CreateEnrollmentFormModalProps } from "components/module/CreateEnrollmentFormModal/CreateEnrollmentFormModal.view";
import { CeoSubmittedFormInstance } from 'services/ceoSubmittedForm';
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { EnrollmentFormServiceInstance } from "services/enrollmentFormService";
import { SurveyServiceInstance } from "services/surveyService";
import { AllErrors } from "types/Errors";
import { EnrollmentFormModel } from "models/EnrollmentForm";
import {CeoSurvey} from "models/CeoSurvey";
import {ceoSurveyToSubmittedForm} from "routes/CeoSurvey/CeoSurvey.transform";

const CreateEnrollmentForm = (): JSX.Element => {
  // MARK:- Hooks
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // MARK:- Query
  const surveyListQuery = useQuery("survey", SurveyServiceInstance.getList, {
    onSuccess: (data) => {
      console.log('Data: ', data);
    },
    onError: (err: AllErrors) => {
      console.error('Error: ', err);
    },
  });

  const create = async (enrollmentData: EnrollmentFormModel, surveyData: CeoSurvey) => {
    const res = await EnrollmentFormServiceInstance.create(enrollmentData);

    if (res.code !== 200) {
      console.log('Error: ', res.message);
    }
    const ceoSurvey = ceoSurveyToSubmittedForm(surveyData, res.body.id as string);
    await CeoSubmittedFormInstance.createCeoSubmittedForm(ceoSurvey);
  }
  // MARK:- Mutation
  // const createEnrollmentFormMutation = useMutation(
  //   create,
  //   {
  //     onSuccess: (data) => {
  //       navigate("/dashboard/enrollment-forms");
  //     },
  //     onError: (err: AllErrors) => {
  //       console.error(err);
  //     },
  //   }
  // );

  // function onSubmit(data: EnrollmentFormModel) {
  //   createEnrollmentForm.mutate(data);
  // }

  const generatedProps: CreateEnrollmentFormModalProps = {
    surveys: surveyListQuery.data?.body || [],
    isLoading: isLoading,
    onSubmit: (data: EnrollmentFormModel, ceoSurvey: CeoSurvey) => {
      setIsLoading(true);
      create(data, ceoSurvey).then(() => navigate("/dashboard/enrollment-forms"))
      .catch(error => console.error(error))
      .finally(() => setIsLoading(false));
    }
  };
  return <CreateEnrollmentFormModal {...generatedProps} />;
};

export default CreateEnrollmentForm;

